<div class="app-admin-wrap" [dir]='layoutConf?.dir'>
  <!-- Header for top navigation layout -->
  <!-- ONLY REQUIRED FOR **TOP** NAVIGATION LAYOUT -->
  @if (layoutConf.navigationPos === 'top') {
    <app-header-top
      [notificPanel]="notificationPanel">
    </app-header-top>
  }
  <!-- Main Container -->
  <mat-sidenav-container [dir]='layoutConf.dir'
    class="app-admin-container app-side-nav-container mat-drawer-transition sidebar-{{layoutConf?.sidebarColor}} topbar-{{layoutConf?.topbarColor}} footer-{{layoutConf?.footerColor}}"
    [ngClass]="adminContainerClasses">
    <mat-sidenav-content>
      <!-- SIDEBAR -->
      <!-- ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT -->
      @if (layoutConf.navigationPos === 'side') {
        <app-sidebar-side
          (mouseenter)="sidebarMouseenter($event)"
        (mouseleave)="sidebarMouseleave($event)"></app-sidebar-side>
      }

      <!-- Top navigation layout (navigation for mobile screen) -->
      <!-- ONLY REQUIRED FOR **TOP** NAVIGATION MOBILE LAYOUT -->
      @if (layoutConf.navigationPos === 'top' && layoutConf.isMobile) {
        <app-sidebar-top></app-sidebar-top>
      }

      <!-- App content -->
      <div class="main-content-wrap" id="main-content-wrap" [perfectScrollbar]="" [disabled]="layoutConf.topbarFixed || !layoutConf.perfectScrollbar">
        <!-- Header for side navigation layout -->
        <!-- ONLY REQUIRED FOR **SIDE** NAVIGATION LAYOUT -->
        @if (layoutConf.navigationPos === 'side') {
          <app-header-side
            [notificPanel]="notificationPanel">
          </app-header-side>
        }

        <div class="rightside-content-hold" id="rightside-content-hold" [perfectScrollbar]="scrollConfig" [disabled]="!layoutConf.topbarFixed || !layoutConf.perfectScrollbar">
          <!-- View Loader -->
          @if (isModuleLoading) {
            <div class="view-loader"
              style="position:fixed; display:flex; flex-direction:column; justify-content: center; justify-items: center;"
              fxLayoutAlign="center center">
              <div class="spinner">
                <div class="double-bounce1 mat-bg-accent"></div>
                <div class="double-bounce2 mat-bg-primary"></div>
              </div>
            </div>
          }
          <!-- Breadcrumb -->
          <app-breadcrumb></app-breadcrumb>
          <!-- View outlet -->
          <div class="container-dynamic careers-page-container">
            <router-outlet></router-outlet>
          </div>
          @if (!layoutConf.footerFixed) {
            <span class="m-auto"></span>
          }
          @if (false && !layoutConf.footerFixed) {
            <app-footer style="margin: 0 -.33rem -.33rem"></app-footer>
          }
        </div>
        @if (layoutConf.footerFixed) {
          <span class="m-auto"></span>
        }
        @if (false && layoutConf.footerFixed) {
          <app-footer></app-footer>
        }
      </div>
      <!-- View overlay for mobile navigation -->
      <div class="sidebar-backdrop"
        [ngClass]="{'visible': layoutConf.sidebarStyle !== 'closed' && layoutConf.isMobile}"
      (click)="closeSidebar()"></div>
    </mat-sidenav-content>


    <!-- Notification bar -->
    <mat-sidenav #notificationPanel mode="over" class="" position="end">
      <div class="notification-panel" fxLayout="column">
        <app-notifications [notificPanel]="notificationPanel"></app-notifications>
      </div>
    </mat-sidenav>

    <matx-notifications2></matx-notifications2>
  </mat-sidenav-container>
</div>
